import { render, staticRenderFns } from "./CutoffResults.vue?vue&type=template&id=0645352f&scoped=true"
import script from "./CutoffResults.vue?vue&type=script&lang=ts"
export * from "./CutoffResults.vue?vue&type=script&lang=ts"
import style0 from "./CutoffResults.vue?vue&type=style&index=0&id=0645352f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645352f",
  null
  
)

export default component.exports